// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clearance-question .clearance-question-answers{display:flex;gap:0.75rem;justify-content:center}.clearance-question .clearance-question-answers .btn{min-width:120px}.clearance-question .clearance-form{margin-bottom:2rem}\n", ""]);
// Exports
module.exports = exports;
